var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',{staticClass:"bg-white",attrs:{"title":_vm.$t('globals.type.groups_menu')}},[_c('NavGroupsLinkEntry',{attrs:{"entry":_vm.groupMenu,"application-count":_vm.applicationCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }